module.exports = __webpack_public_path__ + "static/media/AoA_HomeSections_Bg02-sm.757ce592.jpg";